'use client';

import {
  AddToBasketButtonTailwind,
  type AddToBasketButtonTailwindProps,
} from '@packages/modules/src/AddToBasketButton/AddToBasketButtonTailwind.client';
import { AddToBasketLayer } from '@packages/product/src/components/AddToBasketLayer/AddToBasketLayer.client';

export type AddToBasketButtonWithLayerProps = AddToBasketButtonTailwindProps;

export const AddToBasketButtonWithLayer = (props: AddToBasketButtonWithLayerProps) => (
  <AddToBasketButtonTailwind {...props}>
    {(layerData, lineItem) => <AddToBasketLayer data={layerData} lineItem={lineItem} />}
  </AddToBasketButtonTailwind>
);
